export const ALL_STORES_KEY = 'all-stores';
export const ALL_PROPERTIES_KEY = 'all-properties';
export const getAllStoresOptionItem = (label: string) => ({ value: ALL_STORES_KEY, label: label });
export const getAllPropertiesOptionItem = (label: string) => ({
  value: ALL_PROPERTIES_KEY,
  label: label,
});
